





















































































































import Vue from "vue";
import Util from "./../../lib/util";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import SetupOwners from "./setup-owners.vue";
import RenameAccount from "./rename-account.vue";
import ChangeInvoiceEmail from "./change-invoice-email.vue";
import UpdateCreditCard from "./update-credit-card.vue";
import BillingAccount from "../../store/entities/billingAccount";
import UserAvatar from "../common/user-avatar.vue";

export default Vue.extend({
  name: "AccountInfo",
  components: { SetupOwners, RenameAccount, ChangeInvoiceEmail, UpdateCreditCard, UserAvatar },
  data() {
    return {
      showRenameAccount: false,
      renameAccountModel: {
        accountName: null,
      },
      showOwnerSetup: false,
      showUpdateCreditCard: false,
      showChangeInvoiceEmail: false,
      changeInvoiceEmailModel: {
        emailAddress: null,
      },
    };
  },
  computed: {
    ...mapState("billing", ["loading", "billingAccount"]),
    owners() {
      let context = this as any;
      let billingAccount = context.billingAccount as BillingAccount;
      let owners = billingAccount && billingAccount.members ? billingAccount.members.filter((m) => m.role === 1) : [];
      return owners.sort((a, b) => {
        return a.memberId != context.billingAccount.originalOwnerId && b.memberId != context.billingAccount.originalOwnerId ? 0 : a.memberId != context.billingAccount.originalOwnerId ? 1 : -1;
      });
    },
    billingAccountCreateDate() {
      let context = this as any;
      return moment(context.billingAccount.currentPlanStartDate).format("L");
    },
    billingAccountNextChargeDate() {
      let context = this as any;
      return context.billingAccount.currentPlanEndDate ? moment(context.billingAccount.currentPlanEndDate).format("L") : "";
    },
    // billingAccountNextChargeDate() {
    //   let context = this as any;
    //   return moment(context.billingAccount.currentPlanEndDate).format("L");
    // },
    trialing() {
      let context = this as any;
      return context.billingAccount.status === 1;
    },
    activeWithoutCancel() {
      let context = this as any;
      return context.billingAccount.cancelAt === null && (context.billingAccount.status === 3 || context.billingAccount.status === 6);
    },
    willBeCanceled() {
      let context = this as any;
      return context.billingAccount.cancelAt !== null;
    },
    willBeCanceledAt() {
      let context = this as any;
      return context.billingAccount.cancelAt !== null ? moment(context.billingAccount.cancelAt).format("L") : "";
    },
    freeTrialStartDate() {
      let account = (this as any).billingAccount;
      return account.freeTrial && account.freeTrial.startDate ? moment(account.freeTrial.startDate).format("L") : "";
    },
    freeTrialEndDate() {
      let account = (this as any).billingAccount;
      return account.freeTrial && account.freeTrial.endDate ? moment(account.freeTrial.endDate).format("L") : "";
    },
  },
  watch: {},
  mounted() {},
  methods: {
    handleShowOwnerSetup() {
      let context = this as any;
      this.showOwnerSetup = true;
    },
    handleShowRenameAccount() {
      let context = this as any;
      this.renameAccountModel = {
        accountName: context.billingAccount.name,
      };

      this.showRenameAccount = true;
    },
    handleCancelRenameAccount() {
      this.showRenameAccount = false;
    },
    handleShowUpdateCreditCard() {
      this.showUpdateCreditCard = true;
    },
    handleCancelUpdateCreditCard() {
      this.showUpdateCreditCard = false;
    },
    handleShowChangeInvoiceEmail() {
      let context = this as any;
      this.changeInvoiceEmailModel = {
        emailAddress: context.billingAccount.invoiceEmail,
      };

      this.showChangeInvoiceEmail = true;
    },
    handleCancelChangeInvoiceEmail() {
      this.showChangeInvoiceEmail = false;
    },
  },
});
